module.exports = __webpack_public_path__ + "static/img/zjzcdyh.27b08b40.jpg";